import React from 'react'
import fakeAuth from '../../../fakeAuth';
import { Link } from 'react-router';
import _ from 'lodash';
import { Animated } from "react-animated-css";

class Login extends React.Component {

    state = {
        invlaid: false,
        effects: ['flipInX', 'zoomIn', 'fadeInDownBig']
    }

    componentWillMount() {
        if (fakeAuth.isAuthenticated()) {
            this.props.router.push('/admin/dashboard');
        }
    }

    onLogin = e => {
        e && e.preventDefault && e.preventDefault();

        if (this.txtLogin.value === fakeAuth.hardcoded.u &&
            this.txtPass.value === fakeAuth.hardcoded.p) {
            fakeAuth.authenticate(() => {
                this.props.router.push('/admin/dashboard');
            }, 'token',
                false, {});
        } else {
            this.setState({ invalid: true });
        }
    }

    render() {
        const { invalid = false, effects } = this.state;
        return <Animated animationIn={_.sample(effects)} className="h-100 d-flex flex-column justify-content-center">
            <img alt="" src="/images/logos/logo.png" className="align-self-center margin-bottom" style={{ width: 100 }} />
            <span className="align-self-center anton white font-18 toUpper">Admininstrative Tool</span>
            <figure className="card align-self-center p-4 margin-top">
                <label htmlFor="name" className="hind toUpper">User</label>
                <input ref={(i) => this.txtLogin = i} className="dark white" type="text" required />
                <label htmlFor="name" className="hind toUpper margin-top-half">Password</label>
                <input ref={(i) => this.txtPass = i} className="dark white" type="password" required />
                <button type="submit" className="margin-top btn-white text-center ml-auto margin-bottom" style={{ width: 100 }} onClick={this.onLogin}>LOGIN</button>
                {invalid && <span className="hind red">Invalid credentials!</span>}
            </figure>
            <Link to="/" className="white anton margin-top align-self-center">Go to website <span className="red underlined">here</span></Link>
        </Animated>
    }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/private/login/index.js